module.exports = __webpack_public_path__ + "static/media/event_csv_appload_white.ce062f7a.svg";